import { css } from '@emotion/core';
import { media, variables } from '@domain-group/fe-brary';

// eslint-disable-next-line import/prefer-default-export

// TODO: transparent borders on the flex box for the gaps between cards? https://stackoverflow.com/questions/20626685/better-way-to-set-distance-between-flexbox-items

export const exploreContactButton = css`
  ${media('<tablet')} {
    width: 100%;
    height: 42px;
    margin-top: 18px;
  }
  ${media('>=tablet')} {
    height: 42px;
  }
  border: 1px solid #0ea800;
  color: #0ea800;
`;

export const exploreCardLink = css`
  text-decoration: none;
  display: block;
  width: 100%;
  height: 100%;
  position: relative;
  color: ${variables.colour.neutral700};
  ${media('>=tablet')} {
    padding: 36px 36px 18px 36px;
    display: flex;
    flex-direction: column;
    flex-wrap: no-wrap;
    div.flex-space {
      flex-grow: 1;
    }
    img {
      align-self: flex-start;
    }
  }
`;

export const exploreList = css`
  padding-top: 32px;
  padding-bottom: 32px;
  margin-bottom: 6px;
  ${media('>=tablet')} {
    padding-top: 36px;
    display: flex;
    flex-wrap: wrap;
    align-items: stretch;
    margin: 0 -12px;
    margin-bottom: 16px;
  }
  ${media('>=desktop')} {
    margin-bottom: 35px;
  }
`;

export const exploreCardImage = css`
  width: 77px;
  height: 66px;
  ${media('<tablet')} {
    position: absolute;
    top: 20px;
    left: 20px;
  }
`;

export const exploreCard = css`
  background: #f1fbfb;
  border-radius: 2px;

  h3 {
    font-size: 16px;
    line-height: 24px;
    font-weight: 700;
  }

  ${media('<tablet')} {
    position: relative;
    display: block;
    width: 100%;
    height: 100px;
    margin-bottom: 6px;
    h3 {
      position: absolute;
      top: 38px;
      left: 116px;
    }
    p {
      display: none;
    }
    :last-child {
      background: #fff;
      margin-top: 18px;

      h3 {
        position: relative;
        display: inline;
        top: 0px;
        left: 0px;
      }
      p {
        display: inline;
        ::before {
          content: ' ';
        }
      }
    }
  }

  ${media('>=tablet')} {
    flex-basis: 31%;
    display: inline-block;
    flex-direction: column;
    width: 224px;
    min-height: 310px;
    margin-left: 6px;
    margin-right: 6px;
    margin-bottom: 18px;
    p {
      padding-top: 6px;
    }
    :last-child {
      padding: 36px;
      display: flex;
      flex-direction: column;
      flex-wrap: no-wrap;
      div.flex-space {
        flex-grow: 1;
      }
      span {
        h3 {
          display: inline;
        }
        p {
          display: inline;
          ::before {
            content: ' ';
          }
        }
      }
    }
  }

  ${media('>=desktop')} {
    flex-basis: 30%;
    margin-left: 12px;
    margin-right: 12px;
    min-height: 280px;
  }
`;
